<template>
  <div>
    <header class="tw-py-5 lg:tw-py-10">
      <div class="tw-container tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center tw-gap-5 lg:tw-justify-between lg:tw-gap-0">
        <img src="@/assets/img/logo-white.svg" class="tw-pointer-events-none tw-w-[180px]">
        <div class="info tw-flex tw-justify-center tw-items-center tw-gap-2">
          <div class="tw-text-white tw-text-right">
            <h4 class="tw-uppercase tw-text-xs lg:tw-text-base tw-font-light">Cartão Frota PRIO para empresas</h4>
            <h1 class="tw-font-bold tw-text-xl lg:tw-text-3xl">Simulador de poupança</h1>
          </div>
          <img src="@/assets/img/cards-header.png" class="cards tw-pointer-events-none">
        </div>
      </div>
    </header>
    <main>
      <Form v-if="!$store.state.formSuccess" />
      <FormSuccess v-if="$store.state.formSuccess" />
    </main>
  </div>
</template>
<script>
import Form from '@/components/FormNew.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'NewPage',
    components: {
        Form,
        FormSuccess,
    },
};
</script>

<style lang="scss" scoped>

header {
  @apply tw-bg-no-repeat tw-bg-cover tw-bg-center;
  background-image: url('../assets/img/header-bg.jpg');

  .cards {

    @screen lg {
      width: 130px;
    }
  }
}
</style>
